(function () {
  var SECTION_ATTR = 'data-collection-load-section-id';
  var GRID_SELECTOR = '[data-collection-products]';
  var LOAD_MORE_SELECTOR = '[data-collection-load-more]';
  var VIEW_ALL_SELECTOR = '[data-collection-view-all]';

  function appendPageFromFetch(root, sectionId, grid, nextHref) {
    var url;
    try {
      url = new URL(nextHref, window.location.origin);
    } catch {
      return Promise.reject(new Error('bad url'));
    }
    url.searchParams.set('section_id', sectionId);

    return fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('bad status');
        return res.text();
      })
      .then(function (html) {
        if (!html || !html.trim()) throw new Error('empty html');

        var doc = new DOMParser().parseFromString(html, 'text/html');

        var searchRoot = doc.querySelector('[' + SECTION_ATTR + ']') || doc.body;

        var newGrid =
          searchRoot.querySelector(GRID_SELECTOR) || doc.querySelector(GRID_SELECTOR);
        if (!newGrid) throw new Error('no grid');

        var newItems = newGrid.querySelectorAll('.collection-product');
        if (!newItems.length) throw new Error('no products');

        var fragment = document.createDocumentFragment();
        newItems.forEach(function (node) {
          fragment.appendChild(node.cloneNode(true));
        });
        grid.appendChild(fragment);

        var newPagination =
          searchRoot.querySelector('.collection-pagination') ||
          doc.querySelector('.collection-pagination');
        var oldPagination = root.querySelector('.collection-pagination');
        if (newPagination && oldPagination) {
          oldPagination.innerHTML = newPagination.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (event) {
    var viewAll = event.target.closest(VIEW_ALL_SELECTOR);
    if (viewAll) {
      event.preventDefault();

      if (viewAll.getAttribute('aria-busy') === 'true') return;

      var rootVa = viewAll.closest('[' + SECTION_ATTR + ']');
      if (!rootVa) return;

      var sectionIdVa = rootVa.getAttribute(SECTION_ATTR);
      if (!sectionIdVa) return;

      var gridVa = rootVa.querySelector(GRID_SELECTOR);
      if (!gridVa) return;

      var fallbackHref = viewAll.getAttribute('href');

      function loadAllRemaining() {
        var nextBtn = rootVa.querySelector(LOAD_MORE_SELECTOR);
        if (!nextBtn) return Promise.resolve();

        var nextHref = nextBtn.getAttribute('href');
        if (!nextHref) return Promise.resolve();

        return appendPageFromFetch(rootVa, sectionIdVa, gridVa, nextHref).then(
          loadAllRemaining
        );
      }

      viewAll.setAttribute('aria-busy', 'true');
      viewAll.classList.add('is-loading');

      loadAllRemaining()
        .catch(function () {
          if (fallbackHref) window.location.href = fallbackHref;
        })
        .finally(function () {
          if (viewAll.isConnected) {
            viewAll.removeAttribute('aria-busy');
            viewAll.classList.remove('is-loading');
          }
        });
      return;
    }

    var btn = event.target.closest(LOAD_MORE_SELECTOR);
    if (!btn) return;

    event.preventDefault();

    if (btn.getAttribute('aria-busy') === 'true') return;

    var root = btn.closest('[' + SECTION_ATTR + ']');
    if (!root) return;

    var sectionId = root.getAttribute(SECTION_ATTR);
    if (!sectionId) return;

    var grid = root.querySelector(GRID_SELECTOR);
    if (!grid) return;

    var nextHref = btn.getAttribute('href');
    if (!nextHref) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    appendPageFromFetch(root, sectionId, grid, nextHref)
      .catch(function () {
        window.location.href = nextHref;
      })
      .finally(function () {
        if (btn.isConnected) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        }
      });
  });
})();
